import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {IUserData} from '../models/IUserData';
import {IProfilePicture} from '../models/IProfilePicture';
import {IUploadProfilePicture} from '../models/IUploadProfilePicture';


export interface ITicketsHistorySettings {
  ticketHistoryType: string;
  customDays: number;
}

export interface INomenclature {
  type: string;
  description: string;
}


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private httpClient: HttpClient;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
  }

  public getUserData(): Observable<IUserData> {
    return this.http.get<IUserData>(`${environment.apiUrl}/me`);
    // return this.http.get<IUserData>(`https://login-dev.safe-checkin.com/connect/userinfo`);
  }

  public getChatToken(): Observable<IUserData> {
    return this.http.get<IUserData>(`${environment.apiUrl}/me/chat-token`);
  }

  public saveTicketHistorySettings(settings: ITicketsHistorySettings): Observable<any> {

    return this.http.put<any>(`${environment.apiUrl}/me/data-protection/ticket-history-settings`, settings);
  }

  public getTypesTicketHistory(): Observable<INomenclature[]> {

    return this.http.get<INomenclature[]>(`${environment.apiUrl}/nomenclatures/ticket-history-types`);
  }

  public getTicketHistorySettings(): Observable<ITicketsHistorySettings> {

    return this.http.get<ITicketsHistorySettings>(`${environment.apiUrl}/me/data-protection/ticket-history-settings`);
  }

  public uploadProfilePicture(request: IUploadProfilePicture): Observable<IProfilePicture> {

    return this.http.post<IProfilePicture>(`${environment.loginUrl}/user/uploadProfilePicture`, request);
  }

  public uploadFile(request: File): Observable<IProfilePicture> {
    const formData: FormData = new FormData();
    formData.append('file', request);
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.authService.getToken()}`);

    return this.httpClient.post<IProfilePicture>(`${environment.loginUrl}/user/uploadFile`, formData, {headers});
  }

  public getProfilePicture(apiPath: string): Observable<ArrayBuffer> {

    return this.http.get<ArrayBuffer>(apiPath, {responseType: 'arraybuffer' as 'json'});
  }

  public getProfilePictureUrl(): Observable<string> {

    return this.http.get<string>(`${environment.loginUrl}/user/getProfilePictureUrl`, {responseType: 'text' as 'json'});
  }

  public removeProfilePicture(): Observable<Response> {

    return this.http.delete<Response>(`${environment.loginUrl}/user/removeProfilePicture`);
  }

  public updatePreferredLanguage(preferredLanguageCode: string): Observable<Response> {

    return this.http.put<Response>(`${environment.loginUrl}/user/updatePreferredLanguage/${preferredLanguageCode}`, {
      preferredLanguageCode
    });
  }
}
